import * as colors from 'shared/styles/colors';

export const defaultTheme = {
  StickyFlexItemBackground: colors.backgroundWhite,
};
